import { ErrorMessage, Field, useFormikContext } from "formik";
import BsForm from "react-bootstrap/Form";
import { FormInput } from "../../../../components/form/FormInput";
import { Label } from "../../../../components/form/Label";
import {
  ROLE_OPTIONS,
  COUNTRY_OPTIONS,
} from "../constants/sealRegistrationConstants";
import { SealRegistrationFormData } from "../SealRegistrationContext";

export const RegistrationDetailsSection = () => {
  const { values, setFieldValue } = useFormikContext<SealRegistrationFormData>();

  return (
    <div className="seal-form-section seal-form-section--bordered">
      <h2 className="sub-headline">Registration details</h2>

      <Label
        label="Legal organization name *"
        field="legalOrganizationName"
        className="field-spacing"
      />
      <FormInput
        name="legalOrganizationName"
        type="text"
        autoComplete="organization"
        className="input-text"
      />
      <ErrorMessage
        name="legalOrganizationName"
        className="input-error"
        component="span"
      />
      <span className="form-fields-sub-text">
        Enter the legal entity responsible for this registration and payment.
      </span>

      <Label
        label="Name being registered *"
        field="registeredName"
        className="field-spacing"
      />
      <FormInput
        name="registeredName"
        type="text"
        autoComplete="off"
        className="input-text"
      />
      <ErrorMessage
        name="registeredName"
        className="input-error"
        component="span"
      />
      <span className="form-fields-sub-text">
        Enter one consumer-facing wine brand, vineyard business, importing business, or retail business. This registration applies only to the name entered here.
      </span>
      
      <span className="form-fields-sub-text">
        Additional wine brands require separate registrations, even when they
        share the same parent company, legal owner, producer, importer, or
        management.
      </span>

      <Label
        label="Website *"
        field="organizationWebsite"
        className="field-spacing"
      />
      <FormInput
        name="organizationWebsite"
        type="text"
        autoComplete="url"
        placeholder="https://"
        className="input-text"
      />
      <ErrorMessage
        name="organizationWebsite"
        className="input-error"
        component="span"
      />
      <span className="form-fields-sub-text">
        Enter the primary website for the brand or business being registered.
      </span>

      <Label
        label="Country *"
        field="organizationCountry"
        className="field-spacing"
      />
      <Field name="organizationCountry">
        {({ field, meta }) => (
          <BsForm.Select
            className={`input-text input-height ${
              meta.error && meta.touched ? "input-field-error" : ""
            }`}
            {...field}
          >
            <option value="">Select country</option>
            {COUNTRY_OPTIONS.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </BsForm.Select>
        )}
      </Field>
      <ErrorMessage
        name="organizationCountry"
        className="input-error"
        component="span"
      />
      <span className="form-fields-sub-text">
        <strong>South African Exception</strong>: The OVR Seal is not issued to or valid for use by South African vineyards or wine producers under any circumstances. This is because South Africa already has in place their <a href="https://www.oldvineproject.co.za/aboutus/certifiedheritagevineyardseal">Certified Heritage Vineyard</a> program developed by the <a href="https://www.oldvineproject.co.za">Old Vine Project</a>.  Interested producers from South Africa should engage with the <a href="https://www.oldvineproject.co.za">Old Vine Project</a> and utilize the CHV initiative in lieu of the OVR Seal.
      </span>

      <div className="field-spacing">
        <div className="form-label" style={{ marginBottom: "10px" }}>
          Which role or roles apply to the name being registered? *{" "}
          <span style={{ fontWeight: 400, color: "#616161" }}>
            — Select all that apply.
          </span>
        </div>
        {ROLE_OPTIONS.map((role) => (
          <BsForm.Check
            key={role.key}
            label={role.label}
            className="checkbox-label-text"
            checked={values.roles[role.key] || false}
            onChange={() =>
              setFieldValue(`roles.${role.key}`, !values.roles[role.key])
            }
          />
        ))}
        <ErrorMessage name="roles" className="input-error" component="span" />
        <span className="form-fields-sub-text" style={{ marginTop: "8px", display: "block" }}>
          Distributors, wholesalers, regional marketing bodies, trade
          associations, agencies, consultants, and other third parties are not
          eligible unless they also qualify under one of the roles above.
        </span>
        <span className="form-fields-sub-text">
          None of these describes your organization?{" "}
          <a href="mailto:oldvineregistry@gmail.com" className="form-fields-sub-text-link">
            Contact OVR before registering
          </a>
          .
        </span>
      </div>
    </div>
  );
};
